module.exports = __webpack_public_path__ + "img/login-v2.30054c90.png";